import type { FaireProductEntity } from "../../entity_types/product";

export const p_dja88ypjme: FaireProductEntity = {
  token: "p_dja88ypjme",
  type: "product",
  name: "Custom Baseball Mom Tee with Kids Names and Numbers",
  brandToken: "b_2j7xk5pwsc",
  brandName: "TheKingShirt",
  imageUrl:
    "https://cdn.faire.com/fastly/2a36d8383aaa25eefd8e07b35cad27624afdf619dbece611b2562355b39ca5d9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8697818a002fb308c47cb29ae5fed2264dbb931d1444004b5bc226060dd2fc32.jpeg",
  ],
  priceDollars: 22.99,
  description:
    "Product Details:\n•We use 100% cotton shirts.\n• All shirts are unisex and we use our own brand. (Please check our size chart in our listing.)\n•Heather colored adult shirts use 52% cotton and 48% polyester.\n\n-For detailed sizing information and t-shirt color options, please see listing images.\nOur shirts are small molded. It may be small for your normal size. Please refer to our size chart carefully before ordering.\n-Please check the our size chart and color of the shirt you want before ordering.\n\nWASHING INSTRUCTIONS:\nTurn inside out.\nMachine wash cold.\nTumble dry low.\nDo not bleach.\nDo not iron directly on design.\nHigh quality and super soft, comfortable tshirts.\n\nProcess and Shipping:\nProduction Time 1-3 business day\nUSA Orders / Standard: 3 to 7 business days\nUSA Orders / Rush: 3 to 5 business days\nInternational Orders: 1-2 weeks",
  tags: [],
  msrpDollars: 35.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:48.755Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
